import { useIntl } from 'react-intl'
import { useMemo } from 'react'
import { STATUS_CODE_MAINTENANCE } from 'constants/system'

export const useMaintenanceContent = (status?: number | string) => {
    const { formatMessage } = useIntl()

    const content = useMemo(() => {
        switch (status) {
            case STATUS_CODE_MAINTENANCE:
                return {
                    title: formatMessage({
                        id: 'global.maintenance_503.title',
                        defaultMessage:
                            'Na razie odpoczywamy, ale wrócimy do Ciebie!',
                    }),
                    copy: formatMessage({
                        id: 'global.maintenance_503.description',
                        defaultMessage:
                            'Przepraszamy, nasz system sprzedażowy jest tymczasowo niedostępny z powodu przerwy technicznej. Do czasu wznowienia zachęcamy do zapoznania się z naszymi promocjami.',
                    }),
                }
            default:
                return {
                    title: formatMessage({
                        id: 'global.maintenance_default.title',
                        defaultMessage:
                            'Na razie odpoczywamy, ale niedługo do Ciebie wrócimy!',
                    }),
                    copy: formatMessage({
                        id: 'global.maintenance_default.description',
                        defaultMessage:
                            'Przepraszamy, ale usługa kupowania biletów jest tymczasowo niedostępna. Już pracujemy nad jej przywróceniem, a Ty zrelaksuj się w tym czasie i zapoznaj z naszymi promocjami.',
                    }),
                }
        }
    }, [status])

    return {
        content,
    }
}
